import { motion } from 'framer-motion'
import { useInView } from 'framer-motion'
import { useRef } from 'react'
import { FiBriefcase, FiCalendar, FiMapPin } from 'react-icons/fi'
import './Experience.css'

const Experience = () => {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: "-100px" })

  const experiences = [
    {
      company: 'Avalorn',
      position: 'React Native Developer',
      location: 'Moscow, Russia · Remote',
      startDate: 'Feb 2024',
      endDate: 'Present',
      description: [
        'Developing and maintaining React Native mobile applications',
        'Collaborating with cross-functional teams to deliver high-quality mobile solutions',
        'Implementing best practices for mobile app development and performance optimization',
      ],
      technologies: ['React Native', 'TypeScript', 'JavaScript', 'Mobile Development'],
    },
    {
      company: 'ONEX.AM',
      position: 'Mobile Developer',
      location: 'Yerevan, Armenia',
      startDate: 'Oct 2022',
      endDate: 'Present',
      description: [
        'Built and maintained ONEX delivery service mobile applications for Armenia and Georgia',
        'Developed cross-platform mobile apps using React Native for iOS and Android',
        'Implemented state management with Redux and wrote comprehensive tests with Jest',
        'Collaborated on features for fast and reliable delivery solutions',
      ],
      technologies: ['Jest', 'TypeScript', 'Redux', 'Android', 'React Native', 'iOS'],
    },
    {
      company: 'TookLook',
      position: 'Co-Founder & CTO',
      location: 'Gyumri, Armenia',
      startDate: 'May 2021',
      endDate: 'Present',
      description: [
        'Co-founded and built TookLook, an appointment scheduling app from the ground up',
        'Led technical architecture and development of the mobile application',
        'Integrated real-time features using Socket.io and Firebase for seamless user experience',
        'Implemented Google Maps API for location-based scheduling functionality',
        'Published app on both iOS App Store and Google Play Store',
      ],
      technologies: ['React Native', 'TypeScript', 'iOS', 'Android', 'Google Maps API', 'Firebase', 'Socket.io'],
    },
    {
      company: 'Delta Soft',
      position: 'React Native Developer',
      location: 'Gyumri, Armenia · Remote',
      startDate: 'Jan 2023',
      endDate: 'Aug 2023',
      description: [
        'Developed mobile applications using React Native and WebView technologies',
        'Integrated third-party SDKs including Facebook SDK and AppsFlyer for analytics',
        'Implemented Firebase services for backend functionality',
        'Worked on Android development and Git version control',
      ],
      technologies: ['Webview', 'Firebase', 'Android Development', 'Git', 'Facebook Ads', 'AppsFlyer', 'Facebook SDK'],
    },
    {
      company: 'Brain Fors LLC',
      position: 'React Native Developer',
      location: 'Gyumri, Armenia',
      startDate: 'Jun 2021',
      endDate: 'Nov 2022',
      description: [
        'Developed Mapllo, a dating and meetups mobile application using React Native',
        'Implemented state management with Redux and wrote unit tests with Jest',
        'Built cross-platform mobile apps for iOS and Android',
        'Collaborated on features for social networking and event discovery',
        'Published app on both iOS App Store and Google Play Store',
      ],
      technologies: ['JavaScript', 'Jest', 'TypeScript', 'Redux', 'React Native'],
    },
    {
      company: 'neTTaxi',
      position: 'Mobile Developer',
      location: 'Remote',
      startDate: 'Nov 2020',
      endDate: 'Oct 2022',
      description: [
        'Developed mobile applications for taxi and transportation services',
        'Integrated mapping solutions using Google Maps API and Mapbox',
        'Implemented real-time features with Socket.io for live tracking',
        'Used Firebase and Cloud Firestore for backend services and data management',
      ],
      technologies: ['Firebase', 'Maps', 'React Native', 'Google Maps API', 'Mapbox', 'Socket.io', 'Cloud Firestore'],
    },
  ]

  return (
    <section id="experience" className="experience" ref={ref}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="section-header"
        >
          <h2 className="section-title">
            Work <span className="gradient-text">Experience</span>
          </h2>
          <p className="section-subtitle">
            My professional journey and career milestones
          </p>
        </motion.div>

        <div className="experience-timeline">
          {experiences.map((exp, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -50 }}
              animate={isInView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="experience-item"
            >
              <div className="experience-card">
                <div className="experience-header">
                  <div className="experience-icon">
                    <FiBriefcase />
                  </div>
                  <div className="experience-meta">
                    <h3 className="experience-position">{exp.position}</h3>
                    <h4 className="experience-company">{exp.company}</h4>
                    <div className="experience-details">
                      <span className="experience-location">
                        <FiMapPin /> {exp.location}
                      </span>
                      <span className="experience-date">
                        <FiCalendar /> {exp.startDate} - {exp.endDate}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="experience-body">
                  <ul className="experience-description">
                    {exp.description.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                  <div className="experience-technologies">
                    {exp.technologies.map((tech, idx) => (
                      <span key={idx} className="tech-tag">
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Experience

